import type { FieldExtensionComponentProps } from "@backstage/plugin-scaffolder-react";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import type { FieldValidation } from "@rjsf/utils";



export const ValidateJiraKey = ({
  onChange,
  rawErrors,
  required,
  formData,
}: FieldExtensionComponentProps<string>) => (
  <FormControl
    margin="normal"
    required={required}
    error={rawErrors?.length > 0 && !formData}
  >
    <InputLabel htmlFor="validateName">Jira Project Key</InputLabel>
    <Input
      id="validateName"
      aria-describedby="entityName"
      onChange={(e) => onChange(e.target?.value)}
    />
    <FormHelperText id="entityName">
      Must start with an uppercase letter followed by one or more uppercase alphanumeric characters.
    </FormHelperText>
  </FormControl>
);

/*
 This is a validation function that will run when the form is submitted.
  You will get the value from the `onChange` handler before as the value here to make sure that the types are aligned\
*/

export const jiraKeyValidation = (
  value: string,
  validation: FieldValidation,
) => {
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  if (value.length < 2 || value.length > 10) {
    validation.addError(
      "Project key must be 2-10 characters.",
    );
  }

  if (!/^[A-Z][A-Z0-9]+$/g.test(value)) {
    validation.addError(
      "Project key must start with an uppercase letter followed by one or more uppercase alphanumeric characters",
    );
  }
};